import { render } from "./TopBarPPG.vue?vue&type=template&id=8a8cea18&scoped=true"
import script from "./TopBarPPG.vue?vue&type=script&lang=js"
export * from "./TopBarPPG.vue?vue&type=script&lang=js"

import "./TopBarPPG.vue?vue&type=style&index=0&id=8a8cea18&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8cea18"]])

export default __exports__